import { Megaphone, CalendarDays, Handshake } from "lucide-react";
import { Reveal } from "../components/Reveal";

const SPALTEN = [
  { icon: Megaphone, titel: "Werbung", text: "Erreicht Tausende, aber kaum die 500 Personen, die zählen." },
  { icon: CalendarDays, titel: "Messen", text: "Einmal im Jahr, teuer, und die Richtigen sind selten am Stand." },
  { icon: Handshake, titel: "Empfehlungen", text: "Die besten Kontakte, aber sie kommen, wann sie wollen." }
];

const KACHELN = [
  "Fonds und Asset Manager, die an Family Offices und Institutionelle verkaufen.",
  "Hersteller und Softwareanbieter mit einigen hundert möglichen Abnehmern.",
  "Beratungen und Kanzleien mit Fokus auf eine Funktion in einer Branche."
];

export default function Erkenntnis() {
  return (
    <section className="bg-hellblau py-20 sm:py-28 lg:py-32">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Reveal>
          <div className="flex items-center gap-4">
            <span className="h-px w-10 bg-navy/40" />
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-textgrau">Die Erkenntnis</p>
          </div>
          <h2
            className="mt-6 max-w-3xl text-2xl font-medium leading-snug tracking-[-0.01em] text-textdunkel sm:text-3xl lg:text-4xl"
            data-testid="erkenntnis-ueberschrift"
          >
            Wie viele Menschen können Ihr Angebot überhaupt kaufen?
          </h2>
          <p className="mt-6 max-w-3xl text-base leading-[1.85] text-textgrau">
            Die meisten Unternehmen, mit denen wir arbeiten, verkaufen an eine Gruppe, die man aufschreiben könnte. Ein
            paar hundert, höchstens ein paar tausend Entscheider im DACH-Raum. Für diese Struktur funktionieren die
            üblichen Wege nicht verlässlich:
          </p>
        </Reveal>

        <div className="mt-14 grid gap-10 sm:grid-cols-3 sm:gap-8">
          {SPALTEN.map((s) => (
            <Reveal key={s.titel}>
              <div className="border-t border-navy/15 pt-7">
                <div className="flex h-11 w-11 items-center justify-center rounded-full border border-navy/25 text-navy">
                  <s.icon size={19} strokeWidth={1.25} />
                </div>
                <h3 className="mt-5 text-base font-semibold text-textdunkel">{s.titel}</h3>
                <p className="mt-2 text-sm leading-[1.8] text-textgrau">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-14 grid gap-4 sm:grid-cols-3">
          {KACHELN.map((k, i) => (
            <Reveal key={k} delay={i * 0.05}>
              <div className="h-full rounded-[2px] border border-navy/10 bg-white p-6 text-sm leading-[1.8] text-textdunkel" data-testid={`erkenntnis-kachel-${i + 1}`}>
                {k}
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <p className="mt-16 max-w-3xl text-xl font-semibold leading-snug text-textdunkel sm:text-2xl" data-testid="erkenntnis-abschluss">
            LinkedIn ist der einzige Ort, an dem genau diese Personen mit Name, Funktion und Firma auffindbar sind.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
